import { snakeToCamelCase } from './common';
import { ItemFilter } from '../../graphql/types';
import { findCategoryById } from './findCurrentCategory';
import { BreadcrumbI } from '../../components/Breadcrumbs';
import { GetFilterVariantsForVipPageQuery } from '../../graphql/graphql';
import { BUILDING_TYPE_ID, Cities } from './constants';

export const parseVippedFiltersFromQuery = (query: unknown): ItemFilter => {
  if (!query || typeof query !== 'object') return {} as ItemFilter;

  const { id, nextInternalLocale, ...filterParams } = query;
  return Object.fromEntries(
    Object.entries(filterParams).map(([key, value]) => {
      const newKey = key.replace(/q\[([^\]]*)\]|\[\]/g, '$1');
      const newValue =
        !Number.isNaN(+value) || Array.isArray(value)
          ? value
          : value === 'true';

      return [
        snakeToCamelCase(newKey),
        newKey === 'building_type' ? value : newValue
      ];
    })
  ) as ItemFilter;
};

export const getVippedBreadcrumbs = (
  filters: GetFilterVariantsForVipPageQuery,
  adaptFilter: ItemFilter
): { breadcrumbs: BreadcrumbI[]; currAdaptFilter: ItemFilter } => {
  const { categories, cities, type } = filters;
  const categoryId = adaptFilter?.categoryId || BUILDING_TYPE_ID.FLAT_ALL;
  const cityId = adaptFilter.cityId || Cities.Baku.id;

  const currCategory = findCategoryById(categories, categoryId);
  const currCity = findCategoryById(cities, cityId);
  const currType = findCategoryById(type, adaptFilter.leased);

  const breadcrumbs = [
    {
      stat: 'vipped-breadcrumbs-home',
      text: 'pages.vip.link',
      link: '/'
    },
    currCity && {
      stat: 'vipped-breadcrumbs-city',
      text: currCity?.name,
      link: `/${currCity?.slug}`
    },
    currType && {
      stat: 'vipped-breadcrumbs-building-type',
      text: `main_menu.${adaptFilter.leased ? 'lease' : 'sale'}`,
      link: `/${currType?.name?.toLowerCase()}`
    },
    currCategory && {
      stat: 'vipped-breadcrumbs-category',
      text: currCategory?.name,
      link: `/${currCategory?.slug}`
    }
  ].filter(i => i) as BreadcrumbI[];

  return {
    breadcrumbs,
    currAdaptFilter: { ...adaptFilter, categoryId, cityId }
  };
};
